import React, { Component } from "react";
import Back from "../images/back.svg";
import Logout from "../images/logout.svg";
import Profilee from "../images/profile.svg";
import Profile from "./Profile";
import addtable from "../images/addtable.svg";
// import takeaway from '../images/takeaway.svg'
// import NewFood from '../images/newfood.svg'

import tableqr from "../images/tableqr.svg";
import takeawayqr from "../images/takeawayqr.svg";
import QRObject from "../components/QRObject";
import CustomButton from "../components/CustomButton";
import Loading from "../components/Loading";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import ListViewer from "../components/ListViewer";
import {
  BaseUrl,
  Authorization,
  BaseUrlPublic,
  WebAppUrl,
  isUser,
  LogoutFunction,
} from "../static.js";
import Tooltip from "@mui/material/Tooltip";

export default class QRCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resID: "",
      resNameValue: "",
      qrList: [],
      loading: false,
      currentSelectedType: 1,
      newStation: false,
      ModalShow: false,
      orderProcess: [],
      selectedOrderProcess: [],
      orderProcessId: [],
      currentItemId: null,
      ModalShowOrderProcess: false,
      addProcessToItemLoading: false,
    };

    this.findAllStation = this.findAllStation.bind(this);
    this.readOrderProcess = this.readOrderProcess.bind(this);
  }

  componentDidMount() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    this.setState({ loading: true });

    fetch(BaseUrlPublic + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState(
            { resID: result.result[0].id, resNameValue: result.result[0].name },
            () => {
              this.findAllStation();
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  findAllStation() {
    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findAllStation", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState({ qrList: result.result }, () => {
            this.readOrderProcess();
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  readOrderProcess() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "readOrderProcess", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("readOrderProcess:", result);
        if (result.status === 200) {
          this.setState({
            loading: false,
            orderProcess: result.result,
          });
        } else if (result.status === 403) {
          this.setState({
            loading: false,
            orderProcess: [],
          });
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onBack() {
    this.props.history.push('/Restaurants/'+this.props.match.params.id)
  }

  addNewTable() {
    this.setState({ newStation: true, currentSelectedType: 1 });
  }

  addNewTakeAway() {
    this.setState({ newStation: true, currentSelectedType: 2 });
  }

  cancelClick() {}

  doneClick() {}

  showQRClick() {
    window.open(
      "https://api.qrserver.com/v1/create-qr-code/?color=77-77-77&bgcolor=231-228-223&size=200x200&data=" +
        WebAppUrl +
        this.props.match.params.id
    );
  }

  copyURLClick() {
    // copy('https://api.qrserver.com/v1/create-qr-code/?color=77-77-77&bgcolor=231-228-223&size=200x200&data=https://gomenu.se/delivery/'+this.props.match.params.id)
    copy(WebAppUrl + this.props.match.params.id);
    toast.success("آدرس کپی شد", {
      position: toast.POSITION.BOTTOM_RIGHT,
      hideProgressBar: true,
      autoClose: 6000,
      toastClassName: "toast",
    });
  }

  onSaveStation(result, getOrderProcess) {
    this.setState({ newStation: false, qrList: result }, () => {
      if (getOrderProcess) {
        this.setState({
          currentItemId: getOrderProcess,
          selectedOrderProcess: [],
          ModalShowOrderProcess: true,
        });
      }
    });
  }

  onCancelStation() {
    this.setState({ newStation: false });
  }

  downloadExcelClick() {
    try {
      let data = {
        prefix: WebAppUrl,
        businessId: this.state.resID,
        businessCode: this.props.match.params.id,
      };
      data = Object.assign(data, Authorization());

      fetch(BaseUrl + "getStationUrlList", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.body)
        .then((stream) => new Response(stream))
        .then((response) => response.blob())
        .then((blob) => URL.createObjectURL(blob))
        .then((url) => {
          const link = document.createElement("a");
          link.href = url;
          link.download = "SepandPlus" + Date.now().toString() + ".xlsx";
          document.body.appendChild(link);
          link.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );
          document.body.removeChild(link);
        })
        .catch((err) => {
          toast.error(err.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        });
    } catch (error) {
      toast.error(error.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 8000,
        toastClassName: "toast",
      });
    }
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  onLogout() {
    LogoutFunction();
  }

  onProfile() {
    this.setState({ ModalShow: true });
  }

  onConfirmOrderProcess(list) {
    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      itemId: this.state.currentItemId,
      itemType: "orderStation",
      orderProcessList: list,
    };
    data = Object.assign(data, Authorization());

    console.log(data);
    this.setState({ addProcessToItemLoading: true });
    fetch(BaseUrl + "addNewItemToOP", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          var list = JSON.parse(JSON.stringify(this.state.qrList));
          list.forEach((element) => {
            if (element.id === this.state.currentItemId) {
              element.OPWarning = false;
            }
          });

          this.setState({
            qrList: list,
            selectedOrderProcess: [],
            ModalShowOrderProcess: false,
            addProcessToItemLoading: false,
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error("عملیات با مشکل مواجه شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ addProcessToItemLoading: false });
      });
  }

  render() {
    if (!this.state.loading) {
      return (
        <div className="Login">
          <div className="header">
            <div
              onClick={this.onBack.bind(this)}
              className="linkStyle backButton"
            >
              <img
                src={Back}
                alt=""
                className="backButtonIcon"
                style={{ transform: "rotate(180deg)" }}
              />
              بازگشت
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                height: "fit-content",
                alignItems: "center",
              }}
            >
              <Tooltip title="اطلاعات کاربری" data-place="right">
                <div
                  onClick={this.onProfile.bind(this)}
                  className="linkStyle backButton"
                  // data-tip="اطلاعات کاربری"
                  // data-place="right"
                >
                  <img src={Profilee} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
              <div
                style={{
                  height: "20px",
                  minWidth: "1px",
                  backgroundColor: "var(--brown1)",
                  margin: "0px 5px",
                }}
              />
              <Tooltip title="خروج">
                <div
                  onClick={this.onLogout.bind(this)}
                  className="linkStyle backButton"
                  // data-tip="خروج"
                  // data-place="bottom"
                >
                  <img src={Logout} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
            </div>
          </div>
          <div className="LoginContent">
            <div className="RestaurantsListTitle">QR Code</div>
            <div className="RestaurantsListSubTitle">
              {this.state.resNameValue}
            </div>
          </div>
          <div className="qrContaier">
            <div className="menuQrContainer" style={{ padding: "10px" }}>
              <div className="menuQrContainer">
                <div className="menuQr">
                  <img
                    src={
                      "https://api.qrserver.com/v1/create-qr-code/?color=77-77-77&bgcolor=231-228-223&size=200x200&data=" +
                      WebAppUrl +
                      this.props.match.params.id
                    }
                    alt=""
                    style={{ width: "95%", height: "95%" }}
                  />
                </div>
                <div className="menuQrTitles">
                  <div className="menuQrTitle">کد تصویری رستوران</div>
                  <div style={{ width: "100%" }}>
                    <CustomButton
                      title="نمایش کد تصویری"
                      img={null}
                      backColor="var(--black1)"
                      onClick={this.showQRClick.bind(this)}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <CustomButton
                      title="کپی آدرس"
                      img={null}
                      backColor="var(--black1)"
                      onClick={this.copyURLClick.bind(this)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{ width: "96%", borderTop: "1px solid var(--gray3)" }}
            />

            <div className="qrActionContainer">
              <div
                className="qrActionButton"
                onClick={this.addNewTable.bind(this)}
              >
                <div className="qrActionButtonImg">
                  <img
                    src={addtable}
                    alt=""
                    style={{ width: "100%", height: "100%" }}
                  />
                </div>
                میز جدید
              </div>
              <div style={{ minWidth: "10px" }} />
              <div
                className="qrActionButton"
                onClick={this.addNewTakeAway.bind(this)}
              >
                <div className="qrActionButtonImg">
                  <img
                    src={takeawayqr}
                    alt=""
                    style={{ width: "100%", height: "100%" }}
                  />
                </div>
                بیرون بر جدید
              </div>
            </div>

            <div className="downloadQRExcelButton">
              <CustomButton
                title="دانلود لیست کدهای تصویری"
                img={null}
                backColor="var(--black1)"
                onClick={this.downloadExcelClick.bind(this)}
              />
            </div>

            <div className="qrListContainer">
              {this.state.newStation && (
                <QRObject
                  editMode
                  businessId={this.state.resID}
                  businessCode={this.props.match.params.id}
                  title=""
                  orderStationType={this.state.currentSelectedType}
                  typeImg={
                    this.state.currentSelectedType === 1 ? tableqr : takeawayqr
                  }
                  onSaveStation={this.onSaveStation.bind(this)}
                  onCancelStation={this.onCancelStation.bind(this)}
                  // orderProcess={this.state.orderProcess}
                />
              )}
              {this.state.qrList.map((item, i) => {
                return (
                  <QRObject
                    key={i}
                    businessId={item.businessId}
                    OPWarning={item.OPWarning}
                    businessCode={this.props.match.params.id}
                    qrImg={
                      "https://api.qrserver.com/v1/create-qr-code/?color=77-77-77&bgcolor=231-228-223&size=100x100&data=" +
                      WebAppUrl +
                      this.props.match.params.id +
                      "/" +
                      item.id
                    }
                    id={item.id}
                    isEnable={item.isEnable}
                    title={item.name}
                    onSaveStation={this.onSaveStation.bind(this)}
                    orderStationType={item.orderStationType}
                    typeImg={item.orderStationType === 1 ? tableqr : takeawayqr}
                  />
                );
              })}
            </div>
          </div>

          <Modal
            show={this.state.ModalShow}
            animation={false}
            onHide={this.hideModal.bind(this)}
            centered
          >
            <Profile
              businessCode={this.props.match.params.id}
              hideModal={this.hideModal.bind(this)}
            />
          </Modal>

          <Modal
            show={this.state.ModalShowOrderProcess}
            animation={true}
            size="md"
            backdrop="static"
            backdropClassName="backdropClassName"
            onHide={() => {
              this.setState({ ModalShowOrderProcess: false });
            }}
            centered
          >
            <ListViewer
              listType="orderProcess"
              title="برای ایستگاه روال انتخاب کنید"
              currentSelected={this.state.selectedOrderProcess}
              list={this.state.orderProcess}
              loading={false}
              buttonLoading={this.state.addProcessToItemLoading}
              onConfirmOrderProcess={this.onConfirmOrderProcess.bind(this)}
              hideModal={() => {
                this.setState({ ModalShowOrderProcess: false });
              }}
            />
          </Modal>
          {/* <ReactTooltip className="tooltipContent" effect="solid" clickable /> */}
        </div>
      );
    } else {
      return <Loading />;
    }
  }
}
